import { useState, useEffect, useRef } from 'react'
import { useMemo } from 'react'

import Icon from '../components/Icon'

import { useOnClickOutside } from '../utils'

const DropdownContent = ({ innerRef, open, children }) => {
  return (
    <div
      ref={innerRef}
      className={`absolute top-0 left-0 z-50 ${open ? 'block' : 'hidden'} bg-white 
	border rounded shadow
	w-full`}
      style={{
        transform: 'translate3d(0px, 44px, 0px)',
        minWidth: '10rem',
      }}
    >
      {children}
    </div>
  )
}

export type DropdownListOnChange = (value: string, name: string) => void

const DropdownList = ({
  name,
  value: initValue,
  list,
  onChange = () => {},
}: {
  name: string
  value: string | number
  list: { id: string | number; title: string }[]
  onChange: DropdownListOnChange
}) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useOnClickOutside(ref, () => {
    setOpen(false)
  })

  const handleOpen = () => {
    setOpen((prev) => !prev)
  }

  const handleSelect = (e: React.MouseEvent) => {
    e.stopPropagation()
    setOpen(false)

    const value = e.currentTarget.getAttribute('data-value')
    onChange(value, name)
  }

  const value = useMemo(() => {
    const item = list.find((item) => item.id == initValue)
    return item ? item.title : 'Válassz'
  }, [initValue])

  return (
    <div className="inline-block">
      <div className="relative">
        <div className="flex flex-row border rounded-md bg-white dark:bg-gray-600 px-2 py-1 cursor-pointer">
          <div className="" onClick={handleOpen}>
            {value}
          </div>
          <span className="icon" onClick={handleOpen}>
            <Icon name="expand_more" />
          </span>
        </div>

        <DropdownContent innerRef={ref} open={open}>
          <ul className="flex flex-col p-0 m-0">
            {list &&
              list.map((item: any) => (
                <li
                  className="block list-none px-2 py-1 hover:text-white hover:bg-cyan-500"
                  data-value={item.id}
                  onClick={handleSelect}
                >
                  {item.title}
                </li>
              ))}
          </ul>
        </DropdownContent>
      </div>
    </div>
  )
}

export default DropdownList
